/**
 * Created by swandelow on 8/24/16.
 */
angular.module('CarsSaraBo').factory('MarkupService', ['$resource', '$http', function ($resource, $http) {
	return {
		resource: $resource('../rest/markup',
			{},
			{
				save: {method: 'POST'},
				get: {method: 'GET', isArray: true}
			}),

		fetchCategories: function () {
			return $http.get("../rest/data/markup-categories");
		},

		fetchTableMetadata: function (dimensions) {
			var companies = (!dimensions.companies) ? null : _.map(dimensions.companies.items, function (company) {
				return company.oid;
			});
			var categories = (!dimensions.carCategories) ? null : _.map(dimensions.carCategories.items, function (category) {
				return category.code;
			})

			var filter = {params: {companyOids: companies, categoryCodes: categories}}
			return $http.get("../rest/markup", filter);
		},

		getCompanyMarkup: function (nameLike, filter) {
			var config = {
				params: {
					nameLike: nameLike
				}
			};
			return $http.get("../rest/company/markup-search", config);
		},

		getCategoryMarkup: function (nameLike, filter) {
			var config = {
				params: {
					nameLike: nameLike
				}
			};
			return $http.get("../rest/category", config);
		},

		getMarkups: function (companyOid, pointOfSaleOid, category, period) {
			var config = {
				params: {
					category: category,
					'periodDTO.from': period.from,
					'periodDTO.to': period.to,
				}
			};
			return $http.get("../rest/company/" + companyOid + "/pointofsale/" + pointOfSaleOid + "/markup", config);
		},

		save: function (markup, tree, period) {
			var companies = {};
			_.each(tree, function (elem) {
				companies[elem.companyOid] = elem.categories;
			})
			var requestBody = {
				markup: markup,
				categoriesPerCompany: companies,
				period: period
			};
			return this.resource.save(requestBody).$promise;
		}
	}
}]);




//////////////////
// WEBPACK FOOTER
// ./public/app/markup/markup.service.js
// module id = 891
// module chunks = 3